// Demo deal pipeline. In Phase 3 these come from portal.deals via /api/deals/list.
// Each deal is tagged with route — investors only see deals matching routes
// they're whitelisted for. Routes are shared with portalDemo.js commitment.type.

export const DEMO_DEALS = [
  // UK Whole-Loan B-Notes
  {
    slug: "mayfair-refurb-2026",
    route: "uk_whole_loan_bnote",
    name: "London Mayfair refurb",
    sector: "UK Bridging — refurb",
    jurisdiction: "United Kingdom",
    location: "Mayfair, London W1",
    ticketSize: "£500k–£1m",
    totalSize: 5000000,
    currency: "GBP",
    targetNetIRR: 9.5,
    coupon: "SONIA + 700",
    ltv: "58%",
    termMonths: 12,
    status: "live",
    fundraiseClose: "2026-06-30",
    expectedFunding: "2026-07-15",
    oneLiner: "Prime Mayfair townhouse refurbishment — 12-month bridging facility, B-Note participation behind Daksfirst's wholesale line",
    teaserBullets: [
      "Senior secured against £8.6m valuation (residential)",
      "Strong sponsor — 18+ years UK property development",
      "Clear exit: sale or refinance to high-street BTL on completion",
      "B-Note participation: subordinated to the senior wholesale facility on this loan"
    ]
  },
  {
    slug: "manchester-retail-park",
    route: "uk_whole_loan_bnote",
    name: "Manchester retail park refi",
    sector: "UK Bridging — refi",
    jurisdiction: "United Kingdom",
    location: "Greater Manchester",
    ticketSize: "£250k–£750k",
    totalSize: 3500000,
    currency: "GBP",
    targetNetIRR: 9.0,
    coupon: "SONIA + 650",
    ltv: "55%",
    termMonths: 12,
    status: "live",
    fundraiseClose: "2026-05-31",
    expectedFunding: "2026-06-20",
    oneLiner: "Stabilised retail park refinance ahead of planning permission upside (B-Note)",
    teaserBullets: [
      "Stabilised retail asset with 89% occupancy, 7-year WAULT",
      "Refi from existing high-street lender ahead of 2026 covenant test",
      "Sponsor obtaining outline planning to repurpose 2.1 acres of land bank",
      "Exit: term refinance once planning granted (expected Q4 2026)"
    ]
  },
  {
    slug: "birmingham-development",
    route: "uk_whole_loan_bnote",
    name: "Birmingham development exit",
    sector: "UK Bridging — development exit",
    jurisdiction: "United Kingdom",
    location: "Birmingham, West Midlands",
    ticketSize: "£100k–£500k",
    totalSize: 2000000,
    currency: "GBP",
    targetNetIRR: 10.5,
    coupon: "SONIA + 700",
    ltv: "60%",
    termMonths: 11,
    status: "live",
    fundraiseClose: "2026-05-22",
    expectedFunding: "2026-06-10",
    oneLiner: "Development exit facility for completed scheme — 18-unit mixed-use, partial pre-sales (B-Note)",
    teaserBullets: [
      "Practical completion achieved Q1 2026 — 18 units, mixed-use",
      "Pre-sales: 11 of 18 units exchanged, target full sell-out by Q3",
      "Senior debt being repaid; bridging facility fills 11-month gap to term debt",
      "Independent valuation £4.8m vs £2m facility (60% LTV)"
    ]
  },

  // UK Warehouse First-Loss commitments (separate "deal" type — facility extension / new tranche)
  {
    slug: "warehouse-fl-tranche-3",
    route: "uk_warehouse_fl",
    name: "UK Warehouse First-Loss — Tranche 3",
    sector: "Warehouse pool B-Note",
    jurisdiction: "United Kingdom",
    location: "Across UK bridging book",
    ticketSize: "£1m–£5m",
    totalSize: 12000000,
    currency: "GBP",
    targetNetIRR: 13.5,
    coupon: "B-Note coupon on the warehouse pool — net 12-15% to LP",
    ltv: "n/a (subordinated debt position on the borrowing base)",
    termMonths: 36,
    status: "live",
    fundraiseClose: "2026-07-31",
    expectedFunding: "2026-08-15",
    oneLiner: "Third tranche of the warehouse-pool B-Note — sits below the senior wholesale facility on a £100m+ UK bridging book",
    teaserBullets: [
      "B-Note position on the warehouse pool: subordinated to the senior wholesale facility (A-Note), absorbs losses before senior",
      "Diversified exposure across the entire UK bridging portfolio (no single-deal concentration)",
      "Same structural position as a single-deal B-Note, just pooled across the book",
      "3-year tenor with early redemption optionality after Year 2"
    ]
  },

  // Hospitality
  {
    slug: "project-arthur-sheraton",
    route: "hospitality",
    name: "Project Arthur — Sheraton mezzanine",
    sector: "Hospitality — Sheraton mezzanine",
    jurisdiction: "United Kingdom",
    location: "United Kingdom (location confidential pre-NDA)",
    ticketSize: "£250k–£5m",
    totalSize: 24000000,
    currency: "EUR",
    targetNetIRR: 11.5,
    coupon: "SONIA + 925",
    ltv: "68% combined senior + mezz",
    termMonths: 36,
    status: "live",
    fundraiseClose: "2026-06-15",
    expectedFunding: "2026-07-10",
    oneLiner: "Mezzanine facility into Sheraton-branded hotel acquisition — 36-month term, 11.5% target net IRR",
    teaserBullets: [
      "Senior secured against operating hotel real estate",
      "Established operator with 8 hotels across UK and EU",
      "Mezzanine sits behind senior bank facility, ahead of equity",
      "Refurbishment plan to reposition asset; exit via refinancing or sale"
    ]
  },
  {
    slug: "lq-acquisition-2026",
    route: "hospitality",
    name: "LQ Hotels — portfolio acquisition",
    sector: "Hospitality — senior secured",
    jurisdiction: "United Kingdom",
    location: "Multi-asset UK regional",
    ticketSize: "£500k–£10m",
    totalSize: 86000000,
    currency: "GBP",
    targetNetIRR: 10.0,
    coupon: "SONIA + 750",
    ltv: "62%",
    termMonths: 60,
    status: "live",
    fundraiseClose: "2026-08-31",
    expectedFunding: "2026-10-01",
    oneLiner: "Senior secured facility for portfolio acquisition of 6 regional UK hotels — 5-year term, 10% target net IRR",
    teaserBullets: [
      "6 stabilised UK regional hotels — combined 480 keys",
      "Established operator (track record on 12 prior acquisitions)",
      "Senior secured first-charge across all properties",
      "Exit via refinance to CMBS or term debt at Year 4"
    ]
  },

  // India NCDs Direct
  {
    slug: "kifpl-series-b-ncd",
    route: "india_ncd_direct",
    name: "KIFPL Series B NCD",
    sector: "Indian NBFC — senior secured NCD",
    jurisdiction: "India",
    location: "Mumbai (KIFPL HO)",
    ticketSize: "₹50L–₹5Cr",
    totalSize: 250000000,
    currency: "INR",
    targetNetIRR: 13.0,
    coupon: "13.5% pa, semi-annual",
    ltv: "n/a (corporate debt)",
    termMonths: 36,
    status: "live",
    fundraiseClose: "2026-06-30",
    expectedFunding: "2026-07-20",
    oneLiner: "₹25 Cr Series B NCD issuance — Daksfirst-originated, KIFPL issuer, 36-month tenor, semi-annual coupon",
    teaserBullets: [
      "Senior secured NCD with first-charge security cover 1.45x",
      "KIFPL issuer — 4-year track record, Daksfirst Group entity",
      "BSE-listed for tradability; listed transfer process available",
      "Open to India tax residents and qualifying cross-border investors"
    ]
  },

  // India via Lux Feeder
  {
    slug: "india-lux-c3",
    route: "india_lux_feeder",
    name: "Daksfirst Lux Securitisation — Compartment 3",
    sector: "India private credit (Lux feeder)",
    jurisdiction: "Luxembourg / India",
    location: "Lux SCSp / India underlying",
    ticketSize: "€500k–€10m",
    totalSize: 25000000,
    currency: "EUR",
    targetNetIRR: 11.5,
    coupon: "Pass-through from Indian underlyings",
    ltv: "n/a (feeder)",
    termMonths: 60,
    status: "live",
    fundraiseClose: "2026-09-30",
    expectedFunding: "2026-11-01",
    oneLiner: "Third compartment of Daksfirst Lux Securitisation — feeder into India Special Situations Fund I + curated NCD positions",
    teaserBullets: [
      "Per-investor segregated compartment in Lux Securitisation Vehicle",
      "Underlying: ~70% Daksfirst India SSF I + ~30% curated NCDs",
      "EU-friendly tax wrapper, double-tax-treaty access",
      "5-year term with annual liquidity windows from Year 3"
    ]
  }
];

export function getDemoDeal(slug) {
  return DEMO_DEALS.find(d => d.slug === slug);
}

export function dealsForRoute(route) {
  return DEMO_DEALS.filter(d => d.route === route);
}
